/**
 * Дробные числа в карточке хранятся через точку: так их читают расчёты форм
 * (parseFloat) и отчёты на сервере. А показываются и вводятся — через запятую,
 * как привычно в русской раскладке: точка, набранная в дробном поле, сразу
 * становится запятой (см. components/fields/DecimalInput). На границе поля
 * запятая превращается обратно в точку, а разбор чисел понимает и запятую —
 * для значений, которые уже сохранены так (например, пришли с мобильного
 * приложения).
 */

/**
 * «0,7» → «0.7» — для хранения и расчётов. Пробелы по краям тоже убираем: в
 * числе они ни к чему, а одинокий пробел иначе сохранился бы в поле как значение.
 */
export const toDecimalPoint = (value) => (
  value === null || value === undefined ? value : String(value).trim().replace(/,/g, '.')
);

/** «0.7» → «0,7» — для показа в поле. Пустое значение — пустая строка. */
export const toDecimalComma = (value) => (
  value === null || value === undefined ? '' : String(value).replace(/\./g, ',')
);

/** parseFloat, который понимает и запятую: «0,7» → 0.7, а не 0. */
export const parseDecimal = (value) => parseFloat(toDecimalPoint(value));
